module.exports = "/_next/static/images/5aaf83f096080e886ba7a7c6141facf0-Nubank_HickDuarte_54700_lg.jpg.webp";